import axios from "axios";

export const bookAppointment = (values) => {
  return axios.post(
    "https://asiansurrogacywebapi.acssel.com/api/BookApp",
    {
      Name: values.aName,
      EmailId: values.aEmail,
      PhoneNo: values.aPhone,
      Service: values.aService,
      Department: values.aDepartment,
      DoctorName: values.aDoctorName,
      DOA: values.aDate,
      Time: values.aTime
    },
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  );
};

export const contactus = (values) => {
  return axios.post(
    "https://asiansurrogacywebapi.acssel.com/api/AcmeFertilityWebConatctMsg",
    {
      Name: values.fname,
      EmailId: values.email,
      PhoneNo: values.phone,
      Subject: values.subject,
      ContactMsg: values.message, 
    },
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  );
};